import React, { FC } from "react";
import { Modal } from "antd";
import { PmsMatters, PmsMattersProps } from "./pms-matters";

export type PmsMattersModalProps = PmsMattersProps & {
  open: boolean;
  onClose: () => void;
};

export const PmsMattersModal: FC<PmsMattersModalProps> = ({
  open,
  onClose,
  ...pmsMattersProps
}) => {
  return (
    <Modal
      title={`My ${pmsMattersProps.pmsName} Matters`}
      open={open}
      onCancel={onClose}
      footer={null}
      width={1200}
      bodyStyle={{ padding: "var(--padding-lg)" }}
    >
      <PmsMatters {...pmsMattersProps} />
    </Modal>
  );
};
